import type { FaqItem } from '../components/ds';

export const AI_VIDEO_CONTINUITY_FAQ: readonly FaqItem[] = [
  {
    q: 'How does continuity work across scenes?',
    a: 'The breakdown builds a Project Memory Graph — a persistent record of every character, wardrobe detail, location, prop, and mood. Every shot generates from it and is verified against it, so face, build, and costume hold across the timeline, whatever order shots are generated in or which model renders them.',
  },
  {
    q: 'If I change something, does it re-render everything?',
    a: 'No. Update a character or detail and the graph marks only the shots referencing it as stale, then re-generates just those — each re-verified as it lands. You never re-roll the whole cut to fix one thing.',
  },
  {
    q: 'How many characters can it track?',
    a: 'There\'s no practical cap. Every named character gets its own persistent node, and any number of shots can share the same character memory across the timeline.',
  },
  {
    q: 'How is this different from character reference features in other tools?',
    a: 'Reference images patch one shot at a time, and check nothing. The Project Memory Graph is a system of record for the whole story, and the Coherence Verifier confirms every shot actually matches it — claimed consistency versus verified consistency.',
  },
];
